<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'tipos-servicos') {
            next({ name: 'tipo-servico-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'tipos-servicos') {
            this.$router.replace({ name: 'tipo-servico-list' });
        }
    },
};
</script>
